import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// Build a usable media URL from a stored value.
// Full http(s)/data URLs are returned as-is; storage paths are served via the backend.
export const mediaUrl = (val) => {
  if (!val) return "";
  if (/^(https?:|data:|blob:)/.test(val)) return val;
  if (val.startsWith("/")) return val; // frontend public asset (e.g. /rig/bb-slide.png)
  return `${API}/files/${val}`;
};

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hat_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("hat_token");
      localStorage.removeItem("hat_user");
      // If a staff action failed because the session expired, bounce to login
      // so the user isn't left clicking buttons that silently do nothing.
      const path = window.location.pathname;
      if (path.startsWith("/admin") && path !== "/admin/login") {
        window.location.assign("/admin/login");
      }
    }
    return Promise.reject(err);
  }
);

export default api;
